export function chunkArray(options, chunkSize) {
  options = Object.values(options);
  const length = options.length
  let chunks = []

  for (let i = 0; i < length; i += chunkSize) {
    chunks.push(options.slice(i, i + chunkSize))
  }

  return chunks
}
